import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Panel from '../../../../components/angle/Panel';
import Spinner from '../../../../components/Spinner/index';
import EditTrustForm from '../../components/TrustForm';
import { formInputValidation } from '../../../../services/helper/form-helper';

import {
    fetchCountries,
    fetchStates
} from '../../../../services/redux/commonData/actions';
import {
    updatePendingTrust,
    updateEditPendingTrustPayload
} from '../../../../services/redux/employee/security/actions';
import { editTrust } from '../../../../services/redux/employee/trust/actions';
import { fetchAllClientInformationData } from '../../../../services/redux/employee/clientInformation/actions';

class EditPendingTrust extends Component {
    constructor(props) {
        super(props);
        this.trustFormRef = React.createRef();
    }

    componentDidMount() {
        let {
            fetchCountries,
            fetchStates,
            fetchAllClientInformationData,
            clientInformation,
            commonData
        } = this.props;
        if (commonData.countries.length === 0) {
            fetchCountries();
        }
        if (commonData.states.length === 0) {
            fetchStates();
        }
        if (clientInformation.clients.length === 0) {
            fetchAllClientInformationData();
        }
    }

    onSaveApproveClick = () => {
        let { security, history, editTrust } = this.props;
        let payload = security.editPendingTrust;
        payload = { ...payload, approvedStatus: 2 };
        if (formInputValidation(this.trustFormRef.current)) {
            editTrust(payload).then(response => {
                if (response.status === 200) {
                    history.push('/pending-securities');
                }
            });
        }
    };

    onDenyClick = () => {
        let { security, history, editTrust } = this.props;
        let payload = security.editPendingTrust;
        payload = { ...payload, approvedStatus: 3 };
        editTrust(payload).then(response => {
            if (response.status === 200) {
                history.push('/pending-securities');
            }
        });
    };

    onCancelClick = () => {
        let { history } = this.props;
        history.push('/pending-securities');
    };

    render() {
        let {
            security,
            commonData,
            clientInformation,
            updateEditPendingTrustPayload,
            roleName
        } = this.props;
        let isAdmin = roleName === 'Administrator';
        let saveApproveButton = isAdmin && (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onSaveApproveClick}
            >
                Save & Approve
            </button>
        );

        let denyButton = isAdmin && (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onDenyClick}
            >
                Deny
            </button>
        );

        let cancelButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onCancelClick}
            >
                Back
            </button>
        );

        const buttonList = [saveApproveButton, denyButton, cancelButton];

        return (
            <div>
                <Panel
                    showHeader
                    header="Edit Pending Trust"
                    showFooter
                    footerComponents={buttonList}
                >
                    <div className="col-lg-6 col-md-8 col-sm-12">
                        <EditTrustForm
                            roleName={roleName}
                            trustData={security.editPendingTrust}
                            clientList={clientInformation.clients}
                            countryList={commonData.countries}
                            stateList={commonData.states}
                            updateTrustData={updateEditPendingTrustPayload}
                            formRef={this.trustFormRef}
                            isEditable={isAdmin}
                        />
                    </div>
                </Panel>
                {security.fetching && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    security: state.employee.security,
    commonData: state.commonData,
    clientInformation: state.employee.clientInformation,
    roleName: state.authentication.user
        ? state.authentication.user.roleName
        : ''
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchCountries,
            fetchStates,
            updatePendingTrust,
            updateEditPendingTrustPayload,
            editTrust,
            fetchAllClientInformationData
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(EditPendingTrust));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/PendingSecurities/EditPendingTrust.js